var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.errors),function(error){return _c('sqr-notification',{key:error.id,attrs:{"id":error.id,"color":"warning","label":error.label,"label-raw":error.label ? null : error.message}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }